import styled, { DefaultTheme, css } from 'styled-components';

import { utils } from '@desygner/ui-common-components';

export const StyledAssetColorPaletteCheckboxWrapper = styled.span<{
  isPaletteSelected?: boolean;
  isSelectionMode?: boolean;
}>`
  aspect-ratio: 1/1;
  ${({ isPaletteSelected, isSelectionMode }) => css`
    display: ${isPaletteSelected || isSelectionMode ? 'inline-block' : 'none'};
  `}
`;

export const StyledAssetColorPaletteWrapper = styled.div<{
  isPaletteSelected?: boolean;
}>`
  ${({ theme, isPaletteSelected }) =>
    css`
      display: flex;
      flex-direction: column-reverse;
      align-items: center;
      padding: ${utils.rem(theme.Spacing.Size.XSmall)};
      gap: ${utils.rem(theme.Spacing.Size.XSmall)};
      border-radius: ${utils.rem(theme.Border.Radius.Small)};
      width: 100%;
      transition: box-shadow ${theme.Transition.Timing.Out};
      cursor: pointer;
      box-shadow: ${isPaletteSelected
        ? `inset 0 0 0 ${utils.rem(theme.Border.Size.Medium)} ${theme.Color.Brand.Primary}`
        : `inset 0 0 0 ${utils.rem(theme.Border.Size.Small)} ${theme.Color.Neutrals.Border}`};
      &:hover {
        box-shadow: inset 0 0 0 ${utils.rem(theme.Border.Size.Medium)} ${theme.Color.Brand.Primary};
        transition: box-shadow ${theme.Transition.Timing.In};
      }

      &:hover ${StyledAssetColorPaletteCheckboxWrapper} {
        display: inline-block;
      }
    `}
`;

export const StyledAssetColorPaletteListWrapper = styled.div<{
  theme: DefaultTheme;
}>`
  display: flex;
  align-items: flex-start;
  align-content: flex-start;
  justify-content: flex-start;
  width: 100%;
  overflow: hidden;

  ${({ theme }) => css`
    border: ${utils.rem(theme.Border.Size.Small)} solid ${theme.Color.Neutrals.Border};
    border-radius: ${utils.rem(theme.Border.Radius.Small)};

    .color-bullet-wrapper {
      flex: 1;
      width: 0; // To make the color bullet take the remaining space
    }
    .color-bullet {
      width: 100%;
    }
  `}
`;

const unsetHeightsAndPaddings = css`
  line-height: unset;
  min-height: unset;
  max-height: unset;
  padding: unset;
`;

export const StyledAssetColorPaletteLabel = styled.div<{ theme: DefaultTheme }>`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    width: 100%;
    gap: ${utils.rem(theme.Spacing.Size.XSmall)};
    height: ${utils.rem(theme.Form.CheckboxSize.Medium)};

    & div:has(input[type='text']) {
      ${unsetHeightsAndPaddings}
      height: 100%;
    }

    & input[type='text'] {
      ${unsetHeightsAndPaddings}
      height: 100%;
      padding-left: ${utils.rem(theme.Spacing.Size.XSmall)};
      padding-right: ${utils.rem(theme.Spacing.Size.XSmall)};
      border-radius: ${utils.rem(theme.Border.Radius.XSmall)};

      &:focus {
        outline: unset;
        border: unset;
        outline: ${utils.rem(theme.Border.Size.Medium)} solid ${theme.Color.Brand.Light};
        box-shadow: inset 0 0 0 ${utils.rem(theme.Border.Size.Medium)} ${theme.Color.Brand.Primary};
      }
    }
  `}
`;

export const StyledAssetColorPaletteExtraWrapper = styled.div`
  margin-left: auto;
  display: flex;
  align-items: center;
  justify-content: center;

  & svg {
    width: ${({ theme }) => utils.rem(theme.Spacing.Size.Medium)};
    height: ${({ theme }) => utils.rem(theme.Spacing.Size.Medium)};
    @media (min-width: ${({ theme }) => theme.Screen.Size.Small}px) {
      width: ${({ theme }) => utils.rem(theme.Spacing.Size.MediumSmall)};
      height: ${({ theme }) => utils.rem(theme.Spacing.Size.MediumSmall)};
    }
  }
`;
